import React, { useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import { useTranslation } from "react-i18next";
import outdatedBrowser from "outdated-browser-rework";
import "outdated-browser-rework/dist/style.css";

import Search from "./Search";

import "../styles/index.scss";

export default () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    outdatedBrowser({
      messages: {
        ko: {
          outOfDate: "브라우저가 오래되었습니다!",
          unsupported: "브라우저가 지원되지 않습니다!",
          update: {
            web: "이 웹 사이트를 올바르게 보려면 브라우저를 업데이트하세요.",
            googlePlay: "Google Play에서 Chrome을 설치하세요.",
            appStore: "설정 앱에서 iOS를 업데이트하세요."
          },
          // You can set the URL to null if you do not want a clickable link or provide
          // your own markup in the `update.web` message.
          url: "http://outdatedbrowser.com/",
          callToAction: "지금 내 브라우저를 업데이트하기",
          close: "닫기"
        }
      },
      language: i18n.language.substring(0, 2)
    });
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Switch>
        <Route path="/">
          <Search />
        </Route>
      </Switch>
    </>
  );
};
